import { Box, Skeleton } from '@mui/material';
import DateChip from 'src/components/DateChip';
import Subtitle from 'src/components/Subtitle';
import { DebentureLiabilityCategory } from 'src/types/operations/debentures';

import OperationDebenturesLiabilityCategoryTable from './OperationDebenturesLiabilityCategoryTable';
import { formatLiabilityCompetence } from '../utils';

interface OperationDebenturesLiabilityDataProps {
  competencia: string | null;
  categories: DebentureLiabilityCategory[];
  isLoading?: boolean;
}

export default function OperationDebenturesLiabilityData({
  competencia,
  categories,
  isLoading = false,
}: OperationDebenturesLiabilityDataProps) {
  if (isLoading) {
    return (
      <Box>
        <Skeleton
          variant="text"
          width={120}
          height={20}
          sx={{ mb: 1, mt: 3 }}
        />
        <Box sx={{ height: 2, backgroundColor: 'black', mb: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={280} />
      </Box>
    );
  }

  return (
    <>
      <Subtitle title="Dados" />
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
        <DateChip
          title="Competência"
          date={formatLiabilityCompetence(competencia)}
        />
      </Box>
      <OperationDebenturesLiabilityCategoryTable categories={categories} />
    </>
  );
}
